import type { CommonImageItemType } from '@/components-biz/ImageSelect';
import { parseContainerDeployConfigObject } from '@/delivery-type-plugin/utils/parseContainerDeployConfigObject';

import type { ServiceFormItem } from '../service/types';
import { inferUsageScenarioFromLegacyItem, normalizeServiceItem } from '../service/usageScenario';

interface ImageDeployApiItem {
  name?: string;
  protocol?: string;
  applicationProtocol?: string;
  tranProtocol?: string;
  /** 镜像预置使用场景（API 字段 usage） */
  usage?: string;
  /** 旧字段，兼容读取 */
  usageScenario?: string;
  port?: number;
  internalPort?: number;
  description?: string;
  path?: string;
  routerPath?: string;
}

/** 将镜像 containerDeployConfig.apis 转为表单服务项 */
function getServicesFromImageApis(apis: ImageDeployApiItem[] | undefined): ServiceFormItem[] | undefined {
  if (!apis || !Array.isArray(apis)) return undefined;
  return apis.map((s) => {
    const row = s as ImageDeployApiItem;
    const draft: ServiceFormItem = {
      name: String(row.name || '').trim() || undefined,
      usageScenario: String(row.usage ?? row.usageScenario ?? '').trim() || undefined,
      protocol: String(row.tranProtocol || '').trim() || undefined,
      internalPort: Number(row.port ?? row.internalPort) || undefined,
      description: String(row.description || '').trim() || undefined,
      applicationProtocol: String(row.protocol || row.applicationProtocol || '').trim() || undefined,
      routerPath: String(row.path || row.routerPath || '').trim() || undefined,
      _isDefault: true,
    };
    const usageScenario = inferUsageScenarioFromLegacyItem(draft) ?? draft.usageScenario;
    return normalizeServiceItem({ ...draft, usageScenario });
  });
}

function parseImageContainerDeployServices(imageItem?: CommonImageItemType): ServiceFormItem[] | undefined {
  if (!imageItem) return undefined;
  const containerDeployConfig = parseContainerDeployConfigObject(imageItem.containerDeployConfig);
  return getServicesFromImageApis(
    Array.isArray(containerDeployConfig.apis) ? (containerDeployConfig.apis as ImageDeployApiItem[]) : undefined,
  );
}

/** 将镜像 containerDeployConfig.apis 解析为表单服务项（供 L2 linkage / CI deployConfig 使用） */
export function parseServicesFromImageItem(imageItem?: CommonImageItemType | null): ServiceFormItem[] | undefined {
  return parseImageContainerDeployServices(imageItem ?? undefined);
}
